import { jsx as o, jsxs as k } from "@emotion/react/jsx-runtime";
import u from "react-use-clipboard";
import { SnippetContainer as x, SnippetClickableContent as S } from "./Snippet.styled.js";
import { Button as I } from "../Button/index.js";
import { Chip as y } from "../Chip/index.js";
import { Icon as f } from "../Icon/index.js";
import { Text as B } from "../Text/index.js";
import { Tooltip as D } from "../Tooltip/index.js";
import { IconPrefix as R } from "../../types/components/icon.js";
const T = 3e3, g = ({
  dataTrackId: t,
  children: i,
  /**
   * `value`: value copied to clipboard
   */
  value: p,
  copyText: e,
  copiedText: c,
  variant: n = "chip",
  /**
   * `chipShape`: Only used for chip variant
   */
  chipShape: a = "cube",
  /**
   * `iconPosition`: positioning of the icon in relation to children
   */
  iconPosition: r = "left"
}) => {
  const [l, h] = u(p, {
    successDuration: T
  }), m = ["fa-clipboard", R.REGULAR], s = n === "chip" ? "primary" : "secondary", C = (_) => {
    _.stopPropagation(), h();
  }, d = /* @__PURE__ */ k(S, { children: [
    r === "left" && /* @__PURE__ */ o(f, { icon: m, iconSize: "16px", color: s }),
    i && /* @__PURE__ */ o(B, { variant: "bodySBold", as: "span", color: s, children: i }),
    r === "right" && /* @__PURE__ */ o(f, { icon: m, iconSize: "16px", color: s })
  ] }), b = n === "chip" ? /* @__PURE__ */ o(y, { onClick: C, dataTrackId: `${t}__snippet_clickable__chip`, chipShape: a, children: d }) : /* @__PURE__ */ o(I, { onClick: C, dataTrackId: `${t}__snippet_clickable__text`, variant: "secondary", appearance: "text", "aria-label": e, children: d });
  return /* @__PURE__ */ o(D, { text: l ? c : e, caret: !1, children: b });
}, G = ({
  dataTrackId: t,
  children: i,
  value: p,
  copyText: e,
  copiedText: c,
  css: n,
  variant: a = "chip",
  chipShape: r = "cube",
  iconPosition: l = "left"
}) => /* @__PURE__ */ o(x, { css: n, children: /* @__PURE__ */ o(g, { variant: a, dataTrackId: t, value: p, copyText: e, copiedText: c, chipShape: r, iconPosition: l, children: i }) });
export {
  G as Snippet
};
